/* eslint-disable react/jsx-pascal-case */
import "./App.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-toastify/dist/ReactToastify.css';
import React, {useState, useEffect, Suspense} from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import {motion, AnimatePresence} from 'framer-motion';
import {ToastContainer} from 'react-toastify';
import {MenuProvider} from "./Template/admin/MenuContext";
import {accountService} from "./Template/admin/AccountService";

// Chargement a la demande : chaque page est un chunk separe,
// ce qui sort les ~129 modules admin du bundle initial.
const TemplateLayouts = React.lazy(() => import("./Template/TemplateLayouts"));
const TemplatePropos = React.lazy(() => import("./Template/TemplatePropos"));
const Privacy = React.lazy(() => import("./Template/Privacy"));
const Faq = React.lazy(() => import("./Template/FAQ"));
const Creation = React.lazy(() => import("./Template/Infos/Creation"));
const Convention = React.lazy(() => import("./Template/Infos/Convention"));
const Dmta = React.lazy(() => import("./Template/Infos/Dmta"));
const Ouverture = React.lazy(() => import("./Template/Infos/Ouverture"));
const Transfert = React.lazy(() => import("./Template/Infos/Transfert"));
const Cession = React.lazy(() => import("./Template/Infos/Cession"));
const Prorogation = React.lazy(() => import("./Template/Infos/Prorogation"));
const Exploitation = React.lazy(() => import("./Template/Infos/Exploitation"));
const Rectification = React.lazy(() => import("./Template/Infos/Rectification"));
const Transformation = React.lazy(() => import("./Template/Infos/Transformation"));
const Responsable = React.lazy(() => import("./Template/Infos/Responsable"));
const Denomination = React.lazy(() => import("./Template/Infos/Denomination"));
const Fermeture = React.lazy(() => import("./Template/Infos/Fermeture"));
const Contact = React.lazy(() => import("./Template/Contact"));
const Dashboard = React.lazy(() => import("./Dashboard"));
const ListeDemandeT = React.lazy(() => import("./Template/admin/typeDemandes/ListeDemandeT"));
const Info_piece = React.lazy(() => import("./Template/admin/typePiece/info_piece"));
const Form_typ_piece = React.lazy(() => import("./Template/admin/typePiece/Form_typ_piece"));
const Edit_typ_dmd = React.lazy(() => import("./Template/admin/typeDemandes/Edit_type_dmd"));
const Form_typ_dmd = React.lazy(() => import("./Template/admin/typeDemandes/Form_typ_dmd"));
const ListeTypePiece = React.lazy(() => import("./Template/admin/typePiece/ListeType_piece"));
const Form_Nivo_Valid = React.lazy(() => import("./Template/admin/NivoValidation/Form_nivo_valid"));
const ListeNivoValid = React.lazy(() => import("./Template/admin/NivoValidation/ListeNivoValid"));
const Info_nivo_valid = React.lazy(() => import("./Template/admin/NivoValidation/info_nivo_valid"));
const Edit_Nivo_Valid = React.lazy(() => import("./Template/admin/NivoValidation/Edit_nivo_valid"));
const Form_Role = React.lazy(() => import("./Template/admin/Role/Form_role"));
const Liste_Role = React.lazy(() => import("./Template/admin/Role/Liste_Role"));
const Info_role = React.lazy(() => import("./Template/admin/Role/Info_role"));
const Edit_role = React.lazy(() => import("./Template/admin/Role/Edit_role"));
const Form_userm = React.lazy(() => import("./Template/admin/user_metier/Form_userm"));
const Info_userm = React.lazy(() => import("./Template/admin/user_metier/Info_userm"));
const Liste_userm = React.lazy(() => import("./Template/admin/user_metier/Liste_userm"));
const Info_dmd = React.lazy(() => import("./Template/admin/typeDemandes/info_dmd"));
const Edit_typ_piece = React.lazy(() => import("./Template/admin/typePiece/Edit_typ_piece"));
const LoginPage = React.lazy(() => import("./Template/admin/LoginPage"));
const Info_Typ_dmd = React.lazy(() => import("./Template/admin/typeDemandes/Info_Typ_dmd"));
const Form_typ_piece_E = React.lazy(() => import("./Template/admin/typePieceEtapeVali/Form_typ_piece_E"));
const ListeTypePiece_E = React.lazy(() => import("./Template/admin/typePieceEtapeVali/ListeType_piece_E"));
const Info_piece_E = React.lazy(() => import("./Template/admin/typePieceEtapeVali/info_piece_E"));
const Edit_typ_piece_E = React.lazy(() => import("./Template/admin/typePieceEtapeVali/Edit_typ_piece"));
const ListesDocument = React.lazy(() => import("./Template/admin/demande/dsps/Listes_document"));
const ListeDemandeaTraiter = React.lazy(() => import("./Template/admin/demande/dsps/Liste_demande_a_traiter"));
const Form_dmd_dsps = React.lazy(() => import("./Template/admin/demande/dsps/Form_dmd_dsps_physique"));
const Form_Rapport = React.lazy(() => import("./Template/admin/Rapport/rapport"));
const Form_user_role = React.lazy(() => import("./Template/admin/user_metier/Form_user_role"));
const ListeDemandeRetire = React.lazy(() => import("./Template/admin/demande/dsps/Liste_demande_retirer"));
const Form_user = React.lazy(() => import("./Template/Form_user"));
const TexteRegle = React.lazy(() => import("./Template/TexteRegle"));
const Info_dmd_rcue = React.lazy(() => import("./Template/admin/demande/dsps/Info_dmd_rcue"));
const Form_Region = React.lazy(() => import("./Template/admin/Region/Form_Region"));
const ListeRegion = React.lazy(() => import("./Template/admin/Region/Liste_Region"));
const Info_Region = React.lazy(() => import("./Template/admin/Region/info_Region"));
const Edit_Region = React.lazy(() => import("./Template/admin/Region/Edit_Region"));
const Form_Province = React.lazy(() => import("./Template/admin/Province/Form_Province"));
const ListeProvince = React.lazy(() => import("./Template/admin/Province/Liste_Province"));
const Info_Province = React.lazy(() => import("./Template/admin/Province/info_Province"));
const Edit_Province = React.lazy(() => import("./Template/admin/Province/Edit_Province"));
const Form_District = React.lazy(() => import("./Template/admin/District/Form_Distric"));
const ListeDistrict = React.lazy(() => import("./Template/admin/District/Liste_Distric"));
const Info_District = React.lazy(() => import("./Template/admin/District/info_District"));
const Edit_District = React.lazy(() => import("./Template/admin/District/Edit_District"));
const Form_Activation = React.lazy(() => import("./Template/Form_Activation"));
const Form_Commune = React.lazy(() => import("./Template/admin/Commune/Form_Commune"));
const ListeCommune = React.lazy(() => import("./Template/admin/Commune/Liste_Commune"));
const Info_Commune = React.lazy(() => import("./Template/admin/Commune/info_Commune"));
const Edit_Commune = React.lazy(() => import("./Template/admin/Commune/Edit_Commune"));
const Form_Gesp = React.lazy(() => import("./Template/admin/GroupEsp/Form_Gesp"));
const ListeGesp = React.lazy(() => import("./Template/admin/GroupEsp/Liste_Gesp"));
const Info_Gesp = React.lazy(() => import("./Template/admin/GroupEsp/info_Gesp"));
const Edit_Gesp = React.lazy(() => import("./Template/admin/GroupEsp/Edit_Gesp"));
const Edit_Esp = React.lazy(() => import("./Template/admin/Esp/Edit_Esp"));
const Info_Esp = React.lazy(() => import("./Template/admin/Esp/info_Esp"));
const Form_Esp = React.lazy(() => import("./Template/admin/Esp/Form_Esp"));
const ListeEsp = React.lazy(() => import("./Template/admin/Esp/Liste_Esp"));
const FormCsps = React.lazy(() => import("./Template/admin/csps/Form_Csps"));
const ListeCsps = React.lazy(() => import("./Template/admin/csps/Liste_Csps"));
const EditCsps = React.lazy(() => import("./Template/admin/csps/Edit_Csps"));
const InfoCsps = React.lazy(() => import("./Template/admin/csps/info_Csps"));
const Edit_userm = React.lazy(() => import("./Template/admin/user_metier/Edit_userm"));
const Test = React.lazy(() => import("./Template/admin/demande/dsps/Test"));
const Choix_dmd = React.lazy(() => import("./Template/admin/demande/dsps/Choix_dmd"));
const Form_dmd_dsps_morale = React.lazy(() => import("./Template/admin/demande/dsps/Form_dmd_dsps_moral"));
const Info_dmd_rcue_user = React.lazy(() => import("./Template/admin/demande/dsps/Info_dmd_rcue_user"));
const ListeDemandeUser = React.lazy(() => import("./Template/admin/demande/dsps/Liste_demande_user"));
const ModifierDemande = React.lazy(() => import("./Template/admin/demande/dsps/ModificationDemande"));
const ComplementDemande = React.lazy(() => import("./Template/admin/demande/dsps/ComplementDemande"));
const Form_dmd_dsps_convension = React.lazy(() => import("./Template/admin/demande/dsps/Form_dmd_dsps_moralconv"));
const ResetPassword = React.lazy(() => import("./Template/admin/ResetPassword"));
const ChangePassword = React.lazy(() => import("./Template/admin/ChangePassword"));
const ChangePasswordUser = React.lazy(() => import("./Template/admin/ChangePasswordUser"));
const Profile = React.lazy(() => import("./Template/admin/user_metier/Info_usermad"));
const Choix_type_dmd = React.lazy(() => import("./Template/admin/demande/Choix_type_dmd"));
const Form_dmd_convention_Promotion = React.lazy(() => import("./Template/admin/demande/dcpp/ficheRenseignement/Form_dmd_convention_Promotion"));
const Form_dmd_convention_oe = React.lazy(() => import("./Template/admin/demande/dcpp/ficheRenseignement/Form_dmd_convention_oe"));
const Maintenance = React.lazy(() => import("./components/Maintenance"));
const ListeDemandeterminer = React.lazy(() => import("./Template/admin/demande/dsps/Liste_demande_terminées"));
const Choix_dmd_conv = React.lazy(() => import("./Template/admin/demande/dcpp/Choix_dmd"));
const Form_Program = React.lazy(() => import("./Template/admin/demande/dcpp/Program_invest/Form_Program"));
const SuivreDemande = React.lazy(() => import("./Template/admin/demande/SuivreDemande"));
const Info_Fiche_user = React.lazy(() => import("./Template/admin/demande/dcpp/ficheRenseignement/InfoFiche_user"));
const Info_Prog_user = React.lazy(() => import("./Template/admin/demande/dcpp/Program_invest/InfoProg_user"));
const Info_demandeur = React.lazy(() => import("./Template/admin/demande/dcpp/ficheRenseignement/InfoDemandeur"));
const AjouteSession = React.lazy(() => import("./Template/admin/demande/dcpp/session/AjouteSession"));
const ListeSession = React.lazy(() => import("./Template/admin/demande/dcpp/session/ListeSession"));
const ListeConvaTraiter = React.lazy(() => import("./Template/admin/demande/dcpp/Liste_conv_a_traiter"));
const ListeSignataire = React.lazy(() => import("./Template/admin/Signataire/ListeSignataire"));
const Signataire = React.lazy(() => import("./Template/admin/Signataire/Signataire"));
const ListesDocumentConvention = React.lazy(() => import("./Template/admin/demande/dcpp/Listes_document"));
const Statistiques = React.lazy(() => import("./Template/admin/demande/dcpp/Statistiques"));
const MembreOp = React.lazy(() => import("./Template/admin/demande/dsps/membresOp"));
const ComplementDemandeConv = React.lazy(() => import("./Template/admin/demande/dcpp/ficheRenseignement/ComplementDemandeConv"));
const ListesConventions = React.lazy(() => import("./Template/admin/demande/dcpp/ListesConventions"));
const DmtaDashboard = React.lazy(() => import("./Template/admin/demande/dmta/DmtaDashboard"));
const DossiersList = React.lazy(() => import("./Template/admin/demande/dmta/DossiersList"));
const DossierCreationForm = React.lazy(() => import("./Template/admin/demande/dmta/DossierCreationFormBootstrap"));
const DossierDetails = React.lazy(() => import("./Template/admin/demande/dmta/DossierDetails"));
const DossierDmtaView = React.lazy(() => import("./Template/admin/demande/dmta/DossierDmtaView"));
const Form_user_dcpp = React.lazy(() => import("./Template/admin/demande/dcpp/Form_user_dcpp"));
const AdminStatisticsDashboard_Dmta = React.lazy(() => import("./Template/admin/demande/dmta/AdminStatisticsDashboard_Dmta"));
const MesDossiersDmta = React.lazy(() => import("./Template/admin/demande/dmta/MesDossiersDmta"));
const ListeUserDCPP = React.lazy(() => import("./Template/admin/demande/dcpp/Liste_user_dcpp"));
const SessionsList = React.lazy(() => import("./Template/admin/demande/dmta/SessionsList"));
const StatistiquesDmta = React.lazy(() => import("./Template/admin/demande/dmta/StatistiquesDmta"));
const Notifications = React.lazy(() => import("./Template/admin/Notifications"));
const EnhancedAdminDashboardDsps = React.lazy(() => import("./Template/admin/demande/dsps/AdminStatisticsDashboardDsps"));

const PageLoader = () => (
    <div
        role="status"
        aria-live="polite"
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "50vh",
        }}
    >
        Chargement...
    </div>
);

// Ajoutez un composant de transition
const pageTransition = {
    initial: {opacity: 0, x: -100},
    animate: {opacity: 1, x: 0},
    exit: {opacity: 0, x: 100},
};
// ... code existant ...
const pageTransitions = {
    initial: {opacity: 0, scale: 0.8}, // Changement de x à scale pour un effet de zoom
    animate: {opacity: 1, scale: 1}, // Changement de x à scale pour un effet de zoom
    exit: {opacity: 0, scale: 0.8}, // Changement de x à scale pour un effet de zoom
};
// ... code existant ... 
const AnimatedRoute = ({children}) => (
    <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageTransition}
        transition={{duration: 0.5}} // Durée de la transition
    >
        {children}
    </motion.div>
);

const AnimatedRouteAutre = ({children}) => (
    <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageTransitions}
        transition={{duration: 0.5}} // Durée de la transition
    >
        {children}
    </motion.div>
);

function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    // const checkToken = () => {
    //   const token = accountService.getToken(); // Récupérer le token
    //   if (token) {
    //     // Vérifier si le token n'est pas expiré
    //     try {
    //       // Décodez le token si nécessaire pour vérifier sa validité
    //       // const decodedToken = jwt_decode(token);
    //       return true;
    //     } catch (error) {
    //       accountService.logout(); // Déconnexion si le token est invalide
    //       return false;
    //     }
    //   }
    //   return false;
    // };

    // useEffect(() => {
    //   const initializeAuth = () => {
    //     const tokenExists = checkToken();
    //     setIsLoggedIn(tokenExists);
    //     setIsLoading(false); // Fin du chargement
    //   };

    //   initializeAuth();
    // }, []);

    const checkToken = () => {
        const token = accountService.getToken();
        if (token) {
            try {
                // Ajout d'une vérification côté serveur
                const isTokenValid = async () => {
                    try {
                        const response = await fetch(`${process.env.REACT_APP_API_URL}/verify-token`, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        });

                        if (!response.ok) {
                            // Token invalide ou serveur down
                            accountService.logout();
                            return false;
                        }
                        return true;
                    } catch (error) {
                        // Erreur de réseau ou serveur down
                        accountService.logout();
                        return false;
                    }
                };

                return isTokenValid();
            } catch (error) {
                accountService.logout();
                return false;
            }
        }
        return false;
    };

    useEffect(() => {
        const initializeAuth = async () => {
            const tokenExists = await checkToken();
            setIsLoggedIn(tokenExists);
            setIsLoading(false);
        };

        initializeAuth();
    }, []);

    // Protection des routes pendant le chargement
    if (isLoading) {
        return <div>Chargement...</div>; // Ou votre composant de chargement
    }

    return (
        <>
            <MenuProvider>
                <AnimatePresence>
                    <Suspense fallback={<PageLoader/>}>
                    <Routes>
                        {/* Routes publiques */}
                        <Route exact path="/" element={<AnimatedRoute><TemplateLayouts/></AnimatedRoute>}/>
                        <Route exact path="/login" element={
                            isLoggedIn ? <Navigate to="/admin" replace/> :
                                <AnimatedRoute><LoginPage setIsLoggedIn={setIsLoggedIn}/></AnimatedRoute>
                        }/>
                        {/* <Route exact path="/page" element={<DashboardPage />} /> */}
                        <Route exact path="/textes" element={<AnimatedRoute> <TexteRegle/> </AnimatedRoute>}/>
                        <Route exact path="/privacy" element={<AnimatedRoute><Privacy/> </AnimatedRoute>}/>
                        <Route exact path="/faq" element={<AnimatedRouteAutre> <Faq/></AnimatedRouteAutre>}/>
                        <Route exact path="/creation" element={<AnimatedRouteAutre> <Creation/></AnimatedRouteAutre>}/>
                        <Route exact path="/convention"
                               element={<AnimatedRouteAutre> <Convention/></AnimatedRouteAutre>}/>
                               <Route exact path="/dmta"
                               element={<AnimatedRouteAutre> <Dmta/></AnimatedRouteAutre>}/>
                        <Route exact path="/ouverture" element={<AnimatedRoute><Ouverture/> </AnimatedRoute>}/>
                        <Route exact path="/transfert" element={<AnimatedRouteAutre><Transfert/></AnimatedRouteAutre>}/>
                        <Route exact path="/cession" element={<AnimatedRoute><Cession/> </AnimatedRoute>}/>
                        <Route exact path="/exploitation" element={<AnimatedRoute><Exploitation/></AnimatedRoute>}/>
                        <Route exact path="/prorogation"
                               element={<AnimatedRouteAutre><Prorogation/></AnimatedRouteAutre>}/>
                        <Route exact path="/rectification" element={<AnimatedRoute><Rectification/></AnimatedRoute>}/>
                        <Route exact path="/transformation"
                               element={<AnimatedRouteAutre><Transformation/></AnimatedRouteAutre>}/>
                        <Route exact path="/fermeture" element={<AnimatedRoute><Fermeture/> </AnimatedRoute>}/>
                        <Route exact path="/changement-responsable"
                               element={<AnimatedRouteAutre><Responsable/></AnimatedRouteAutre>}/>
                        <Route exact path="/changement-denomination"
                               element={<AnimatedRoute><Denomination/></AnimatedRoute>}/>
                        <Route exact path="/contact" element={<AnimatedRouteAutre><Contact/> </AnimatedRouteAutre>}/>
                        <Route exact path="/maintenance"
                               element={<AnimatedRouteAutre><Maintenance/></AnimatedRouteAutre>}/>
                        {/* liste des routes qui ont besoin d'authentification  */}

                        {/* Routes protégées */}
                        <Route exact path="/admin" element={
                            isLoggedIn ? <AnimatedRoute><Dashboard/></AnimatedRoute> :
                                <Navigate to="/login" state={{from: '/admin'}} replace/>
                        }/>

                        {/* Autres routes protégées... */}
                        <Route exact path="/liste_dmd_t" element={
                            isLoggedIn ? <AnimatedRouteAutre><ListeDemandeT/></AnimatedRouteAutre> :
                                <Navigate to="/login" state={{from: '/liste_dmd_t'}} replace/>
                        }/>

                        <Route exact path="/propos" element={<TemplatePropos/>}/>
                        <Route exact path="/textes" element={<TexteRegle/>}/>
                        <Route
                            exact
                            path="/liste_dmd_t"
                            element={
                                isLoggedIn ? <AnimatedRoute> <ListeDemandeT/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-type-demande/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Info_Typ_dmd/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-type-demandes/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute><Info_dmd/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-type-pieces/:id"
                            element={
                                isLoggedIn ? <Info_piece/> : <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/edit_param-type-pieces/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute><Edit_typ_piece/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-type-pieces_E/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute><Info_piece_E/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/edit_param-type-pieces_E/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><Edit_typ_piece_E/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/edit_param-type-demandes/:id"
                            element={
                                isLoggedIn ? <Edit_typ_dmd/> : <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/demande_type"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Form_typ_dmd/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />


                        <Route
                            exact
                            path="/type_piece"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Form_typ_piece/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/liste_type_piece"
                            element={
                                isLoggedIn ? <AnimatedRoute> <ListeTypePiece/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/type_piece_E"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <Form_typ_piece_E/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/liste_type_piece_E"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <ListeTypePiece_E/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/niveau_validation"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <Form_Nivo_Valid/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/liste_niveau_validation"
                            element={
                                isLoggedIn ? <AnimatedRoute> <ListeNivoValid/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-niveau-validation/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <Info_nivo_valid/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />

                        <Route exact path="/edit_param-nivo-valid/:id" element={
                            isLoggedIn ? <Edit_Nivo_Valid/> : <Navigate to="/login" replace/>
                        }/>

                        {/* Routes publiques */}
                        <Route exact path="/changement-responsable" element={<Responsable/>}/>
                        <Route exact path="/changement-denomination" element={<Denomination/>}/>
                        <Route exact path="/contact" element={<AnimatedRoute> <Contact/> </AnimatedRoute>}/>
                        <Route exact path="/maintenance" element={<AnimatedRoute> <Maintenance/> </AnimatedRoute>}/>
                        {/* liste des routes qui ont besoin d'authentification  */}

                        {/* Routes protégées */}
                        <Route exact path="/admin" element={
                            isLoggedIn ? <AnimatedRoute> <Dashboard/> </AnimatedRoute> :
                                <Navigate to="/login" state={{from: '/admin'}} replace/>
                        }/>

                        {/* Autres routes protégées... */}
                        <Route exact path="/liste_dmd_t" element={
                            isLoggedIn ? <AnimatedRoute> <ListeDemandeT/> </AnimatedRoute> :
                                <Navigate to="/login" state={{from: '/liste_dmd_t'}} replace/>
                        }/>

                        <Route exact path="/propos" element={<TemplatePropos/>}/>
                        <Route exact path="/textes" element={<TexteRegle/>}/>
                        <Route
                            exact
                            path="/liste_dmd_t"
                            element={
                                isLoggedIn ? <AnimatedRoute><ListeDemandeT/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-type-demande/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Info_Typ_dmd/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-type-demandes/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Info_dmd/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/ajouter-utilisateur-dcpp"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Form_user_dcpp/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        
                        <Route
                            exact
                            path="/param-type-pieces/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Info_piece/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/edit_param-type-pieces/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Edit_typ_piece/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-type-pieces_E/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Info_piece_E/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/edit_param-type-pieces_E/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <Edit_typ_piece_E/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/edit_param-type-demandes/:id"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Edit_typ_dmd/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/demande_type"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Form_typ_dmd/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />


                        <Route
                            exact
                            path="/type_piece"
                            element={
                                isLoggedIn ? <AnimatedRoute><Form_typ_piece/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/liste_type_piece"
                            element={
                                isLoggedIn ? <AnimatedRoute> <ListeTypePiece/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/type_piece_E"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <Form_typ_piece_E/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/liste_type_piece_E"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <ListeTypePiece_E/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/niveau_validation"
                            element={
                                isLoggedIn ? (
                                    <Form_Nivo_Valid/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/liste_niveau_validation"
                            element={
                                isLoggedIn ? <ListeNivoValid/> : <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/param-niveau-validation/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <Info_nivo_valid/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/edit_param-nivo-valid/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> <Edit_Nivo_Valid/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />

                        {/* Routes pour les regions */}

                        <Route
                            exact
                            path="/region"
                            element={isLoggedIn ? (
                                <AnimatedRoute> <Form_Region/> </AnimatedRoute>
                            ) : (
                                <Navigate to="/login" replace/>
                            )

                            }
                        />
                        <Route
                            exact
                            path="/liste_region"
                            element={isLoggedIn ? (
                                <AnimatedRouteAutre> <ListeRegion/> </AnimatedRouteAutre>
                            ) : (
                                <Navigate to="/login" replace/>
                            )

                            }
                        />
                        <Route
                            exact
                            path="/voir-region/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> < Info_Region/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/edit-region/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> < Edit_Region/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />

                        {/* Routes pour les Provinces */}
                        <Route
                            exact
                            path="/province"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> < Form_Province/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/liste_province"
                            element={
                                <AnimatedRouteAutre> <ListeProvince/> </AnimatedRouteAutre>
                            }
                        />
                        <Route
                            exact
                            path="/voir-province/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> < Info_Province/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/edit-province/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> < Edit_Province/></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />

                        {/* Routes pour les Communes */}

                        <Route
                            exact
                            path="/commune"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute>< Form_Commune/></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/liste_commune"
                            element={
                                isLoggedIn ? (
                                    < ListeCommune/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/voir-commune/:id"
                            element={
                                isLoggedIn ? (
                                    < Info_Commune/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/edit-commune/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRouteAutre> < Edit_Commune/> </AnimatedRouteAutre>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        {/* Routes pour les districts */}

                        <Route
                            exact
                            path="/district"
                            element={
                                isLoggedIn ? (
                                    < Form_District/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/liste_district"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> < ListeDistrict/></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/voir-district/:id"
                            element={
                                isLoggedIn ? (
                                    < Info_District/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/edit-district/:id"
                            element={
                                isLoggedIn ? (
                                    < Edit_District/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        {/* Routes pour les esp */}

                        <Route
                            exact
                            path="/esp"
                            element={
                                isLoggedIn ? (
                                    < Form_Esp/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/liste_esp"
                            element={
                                isLoggedIn ? (
                                    < ListeEsp/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/documents-charger"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRouteAutre> < ListesDocument/> </AnimatedRouteAutre>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                             <Route
                            exact
                            path="/documents-charger-convention"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRouteAutre> < ListesDocumentConvention/> </AnimatedRouteAutre>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />

                        {/* Routes DMTA */}
                        <Route
                            exact
                            path="/dmta/dashboard"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><DmtaDashboard /></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />
                        <Route
                            exact
                            path="/dmta/dossiers"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><DossiersList /></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />
                        <Route
                            exact
                            path="/dmta/dossiers/nouveau"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><DossierCreationForm /></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />
                        <Route
                            exact
                            path="/dmta/dossiers/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><DossierDetails /></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />
                        <Route
                            exact
                            path="/dossier-dmta-view/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><DossierDmtaView /></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />
                        <Route
                            exact
                            path="/dmta/statistiques"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><AdminStatisticsDashboard_Dmta /></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />
                        <Route
                            exact
                            path="/dmta/mes-dossiers"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><MesDossiersDmta /></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />
                            <Route
                            exact
                            path="/statistiques-convention"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRouteAutre> < Statistiques/> </AnimatedRouteAutre>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                           <Route
                            exact
                            path="/membres-op"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRouteAutre> <MembreOp/> </AnimatedRouteAutre>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/voir-esp/:id"
                            element={
                                isLoggedIn ? (
                                    < Info_Esp/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/edit-esp/:id"
                            element={
                                isLoggedIn ? (
                                    < Edit_Esp/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        
                        {/* Routes pour les CSPS */}
                        <Route
                            exact
                            path="/csps/nouveau"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><FormCsps/></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/liste_csps"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><ListeCsps/></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/csps/voir/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><InfoCsps/></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/csps/modifier/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute><EditCsps/></AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        {/* Routes pour les groupes d'esp*/}

                        <Route
                            exact
                            path="/gesp"
                            element={
                                isLoggedIn ? (
                                    < Form_Gesp/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/liste_gesp"
                            element={
                                isLoggedIn ? (
                                    < ListeGesp/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/voir-gesp/:id"
                            element={
                                isLoggedIn ? (
                                    < Info_Gesp/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )


                            }
                        />
                        <Route
                            exact
                            path="/edit-gesp/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> < Edit_Gesp/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/generer_rapport"
                            element={
                                isLoggedIn ? <Form_Rapport/> : <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            //path="/param-type-demandes/:id/param-niveau-validations"
                            path="/nivo"
                            element={
                                <Form_Nivo_Valid/>
                            }
                        />
                        <Route
                            exact
                            path="/ajoute_role"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute>< Form_Role/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/liste_role"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute>< Liste_Role/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/role/:id"
                            element={
                                isLoggedIn ? (
                                    < Info_role/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />
                        <Route
                            exact
                            path="/edit_role/:id"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute> < Edit_role/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )

                            }
                        />

                        <Route
                            exact
                            path="/activation_compte"
                            element={
                                <AnimatedRouteAutre> <Form_Activation/> </AnimatedRouteAutre>
                            }
                        />
                        <Route
                            exact
                            path="/reset-password"
                            element={
                                <AnimatedRoute> <ResetPassword/></AnimatedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/change-password"
                            element={
                                <AnimatedRoute> <ChangePassword/></AnimatedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/changepassworduser"
                            element={
                                <AnimatedRoute> <ChangePasswordUser/></AnimatedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/user_metier"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Form_userm/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route exact path="/user_inscription" element={<AnimatedRoute> <Form_user/> </AnimatedRoute>}/>
                        <Route
                            exact
                            path="/login"
                            element={<AnimatedRouteAutre> <LoginPage setIsLoggedIn={setIsLoggedIn}/>
                            </AnimatedRouteAutre>}
                        />

                        <Route
                            exact
                            path="/liste_demande_user"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRouteAutre> <ListeDemandeUser/> </AnimatedRouteAutre>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/liste_demande_a_traiter"
                            element={
                                isLoggedIn ? (
                                    <AnimatedRouteAutre> <ListeDemandeaTraiter/> </AnimatedRouteAutre>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/user_metier_role"
                            element={
                                isLoggedIn ? <Form_user_role/> : <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/liste_demande_retire"
                            element={
                                isLoggedIn ? (
                                    <ListeDemandeRetire/>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />
                        <Route
                            exact
                            path="/liste_user_metier"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Liste_userm/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/user-maj/:userId"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Edit_userm/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/user-metiers"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Info_userm/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        <Route
                            exact
                            path="/profile_user"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Profile/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />
                        {/* <Route
            exact
            path="/demandes/12efld/çsd/6-ld133-/:id-236dad/2345FTksmckd"
            element={
              isLoggedIn ? <Info_dmd_rcu /> : <Navigate to="/login" replace />
            }
          /> */}

                        <Route
                            exact
                            path="/demandes-view/:demandeId"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Info_dmd_rcue/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/demandes-view_user/:demandeId"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Info_dmd_rcue_user/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/demandes-terminer"
                            element={
                                isLoggedIn ? <AnimatedRoute> <ListeDemandeterminer/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        {/* liste des routes qui n'ont pas besoin d'authentification */}


                        <Route
                            exact
                            path="/faire_demande/12d38g8-/:id-a3894DI39"

                            element={
                                isLoggedIn ? (
                                    <AnimatedRoute>< Form_dmd_dsps/> </AnimatedRoute>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )}
                        />

                        <Route
                            exact
                            path="/faire_demande_physique"

                            element={isLoggedIn ? (
                                <AnimatedRouteAutre> < Form_dmd_dsps/> </AnimatedRouteAutre>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />

                        <Route
                            exact
                            path="/faire_choix_type_demande"

                            element={isLoggedIn ? (
                                <AnimatedRouteAutre> < Choix_type_dmd/> </AnimatedRouteAutre>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />

                        <Route
                            exact
                            path="/faire_demande_morale"
                            element={isLoggedIn ? (
                                <AnimatedRoute> <Form_dmd_dsps_morale/> </AnimatedRoute>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />

                        <Route
                            exact
                            path="/faire_demande_morale_conv"
                            element={isLoggedIn ? (
                                <AnimatedRoute> <Form_dmd_dsps_convension/> </AnimatedRoute>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />
                        <Route
                            exact
                            path="/faire_choix"
                            element={isLoggedIn ? (
                                <Choix_dmd/>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />

                        {/* liste des routes pour la convention */}
                        <Route
                            exact
                            path="/faire_demande_convention_promotion"
                            element={isLoggedIn ? (
                                <AnimatedRouteAutre><Form_dmd_convention_Promotion/></AnimatedRouteAutre>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />
     <Route
                            exact
                            path="/faire_demande_convention_ouverture_exploitation"
                            element={isLoggedIn ? (
                                <AnimatedRouteAutre><Form_dmd_convention_oe/></AnimatedRouteAutre>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />
                        <Route
                            exact
                            path="/faire_demande_convention_Rss"
                            element={isLoggedIn ? (
                                <AnimatedRouteAutre><Form_Program/></AnimatedRouteAutre>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />

                        <Route
                            exact
                            path="/demande/dcpp/ListesConventions"
                            element={isLoggedIn ? (
                                <AnimatedRouteAutre> <ListesConventions/> </AnimatedRouteAutre>
                            ) : (
                                <Navigate to="/login" replace/>
                            )}
                        />

                        <Route
                            exact
                            path="/faire_demande"
                            element={<Test/>}
                        />

                        <Route path="/demandes/:demandeId/modifier" element={isLoggedIn ? (
                            <AnimatedRouteAutre> <ModifierDemande/></AnimatedRouteAutre>
                        ) : (
                            <Navigate to="/login" replace/>
                        )}/>

                        <Route path="/faire_choix_convention" element={isLoggedIn ? (
                            <AnimatedRouteAutre> <Choix_dmd_conv/></AnimatedRouteAutre>
                        ) : (
                            <Navigate to="/login" replace/>
                        )}/>

                        <Route path="/suivre_demandes" element={isLoggedIn ? (
                            <AnimatedRouteAutre> <SuivreDemande/></AnimatedRouteAutre>
                        ) : (
                            <Navigate to="/login" replace/>
                        )}/>

                        <Route path="/demandes/:demandeId/complement" element={isLoggedIn ? (
                            <AnimatedRoute><ComplementDemande/></AnimatedRoute>
                        ) : (
                            <Navigate to="/login" replace/>
                        )}/>

                        <Route path="/demandes_convention/:demandeId/complement" element={isLoggedIn ? (
                            <AnimatedRoute><ComplementDemandeConv/></AnimatedRoute>
                        ) : (
                            <Navigate to="/login" replace/>
                        )}/>

                        <Route
                            exact
                            path="/fiche-view-user/:demandeId"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Info_Fiche_user/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/demandeur-view-user/:demandeId"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Info_demandeur/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/prog-view_user/:demandeId"
                            element={
                                isLoggedIn ? <AnimatedRoute> <Info_Prog_user/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/Ajoutersession"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <AjouteSession/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/session"
                            element={
                                isLoggedIn ? <AnimatedRoute> <ListeSession/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />


                                                <Route
                            exact
                            path="/dmta/sessions-commission"
                            element={
                                isLoggedIn ? <AnimatedRoute> <SessionsList/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                                                <Route
                            exact
                            path="/dmta/sessions-comite"
                            element={
                                isLoggedIn ? <AnimatedRoute> <SessionsList/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                         <Route
                            exact
                            path="/dmta/statistiques_aemt"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <StatistiquesDmta/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        
                         <Route
                            exact
                            path="/dsps/statistiques_dsps"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <EnhancedAdminDashboardDsps/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                            <Route
                            exact
                            path="/notifications"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Notifications/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/liste_Conventions_a_traiter"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <ListeConvaTraiter/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/signataire_param"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <Signataire/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                         <Route
                            exact
                            path="/utilisateurs_dcpp"
                            element={
                                isLoggedIn ? <AnimatedRouteAutre> <ListeUserDCPP/> </AnimatedRouteAutre> :
                                    <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            exact
                            path="/signataire"
                            element={
                                isLoggedIn ? <AnimatedRoute> <ListeSignataire/> </AnimatedRoute> :
                                    <Navigate to="/login" replace/>
                            }
                        />


                        <Route exact path="*" element={<TemplateLayouts/>}/>


                    </Routes>
                    </Suspense>
                </AnimatePresence>
            </MenuProvider>
            <ToastContainer
                position="top-right"
                autoClose={3000}  // Temps d'affichage des toasts (3 secondes)
                hideProgressBar={false}  // Gardez la barre de progression visible
                newestOnTop={false}  // Affiche les toasts les plus récents en bas
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
}

export default App;
